
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/natijalar",
      function () {
        return require("private-next-pages/natijalar/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/natijalar"])
      });
    }
  